import * as Sentry from '@sentry/browser'

Sentry.init({
  dsn: import.meta.env.SENTRY_JS_DSN ?? 'https://27dbeb10699728f51ca5f1ce10415659@o117921.ingest.us.sentry.io/4508180884619264',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.thirdPartyErrorFilterIntegration({
      // Specify the application keys that you specified in the Sentry bundler plugin
      filterKeys: ['eco-website'],

      // Defines how to handle errors that contain third party stack frames.
      // Possible values are:
      // - 'drop-error-if-contains-third-party-frames'
      // - 'drop-error-if-exclusively-contains-third-party-frames'
      // - 'apply-tag-if-contains-third-party-frames'
      // - 'apply-tag-if-exclusively-contains-third-party-frames'
      behaviour: 'drop-error-if-contains-third-party-frames',
    }),
    // Explicitly disable Session Replay
    Sentry.replayIntegration({
      disabled: true,
    }),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  release: "${APP_NAME}@6.3.5",
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [],
  denyUrls: [
    // Add URLs or patterns of third-party scripts to deny here
    /googletagmanager\.com/i,
    /hubspot\.com/i,
    /intercom\.io/i,
    // Example: /cdn\.thirdparty\.com/i,
  ],
  // Session Replay - add this config back, even though we removed it was still capturing
  // Now we set them to 0 to disable, just in case, as well as setting disabled to true
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
})
